export const GET_MAINTAIN_LIST = 'maintain/GET_MAINTAIN_LIST'
export const GET_MAINTAIN_TOTAL = 'maintain/GET_MAINTAIN_TOTAL'
export const SET_INPUT_VALUE = 'maintain/SET_INPUT_VALUE'
export const SET_CURRENT = 'maintain/SET_CURRENT'
export const PHOTO_SHOW = 'maintain/PHOTO_SHOW'
export const PHOTO_HIDE = 'maintain/PHOTO_HIDE'
export const STATISTICS_SHOW = 'maintain/STATISTICS_SHOW'
export const STATISTICS_HIDE = 'maintain/STATISTICS_HIDE'
export const GET_STATISTICS_COUNT = 'maintain/GET_STATISTICS_COUNT'
export const GET_STATISTICS_LIST = 'maintain/GET_STATISTICS_LIST'